import { setTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { STEP_KEY_V2 } from "../../../../util/varibles/constants";
import { IActivityLog } from "../../../../util/varibles/interface";
import NextTabButton from "../NextTabButton";
import Steps from "../Steps";
import Completed from "./_Completed";
import ServiceTask from "./_ServiceTask";
import Start from "./_Start";

function StepView({ activity_log, step }: { activity_log: IActivityLog[], step: number }) {
    const log = activity_log[step];
    const set = setTrackingOp();

    switch (log?.key) {
        case STEP_KEY_V2.START_SERVICE: {

            return <>
                <Start log={log} />
                <NextTabButton
                    name="Service task detail"
                    onClick={() => {
                        set({ step: step + 1 });
                    }}
                />
            </>
        }
        case STEP_KEY_V2.PROCESS_SERVICE: {
            return <ServiceTask log={log} stepIndex={step} />
        }
        case STEP_KEY_V2.COMPLETED_SERVICE: {
            return <Completed log={log} start={activity_log[0]} />
        }
        default:
            return <></>
    }
}

export default function ServiceSteps() {
    const [activity_log = []] = useTrackingOp(state => state.op?.activity_log);
    const [step] = useTrackingOp(state => state.step);
    const [pause] = useTrackingOp(state => state.pause);

    return <div className="w-full h-full min-h-min flex flex-col relative px-[20px] overflow-hidden">
        <Steps activity_log={activity_log} step={step} />
        <div className="pt-3 w-[calc(100%+20px)] mr-[-20px] pr-[20px] h-full min-h-0 flex-1 flex flex-col overflow-y-auto">
            <StepView activity_log={activity_log} step={step} />
            {pause !== -1 && (
                <div className="absolute inset-y-0 -left-[20px] -right-[20px] z-20 bg-[#5E6D78] opacity-[38%]" />
            )}
        </div>
    </div>
}
